<template>
  <v-card class="mt-2 pa-5 table-card" outlined>
    <v-container v-blur="blurConfig" fluid>
      <v-row class="mb-10" align="center" justify="center">
        <h2>{{ $t('title_ClubPerformance') }}</h2>
      </v-row>
      <v-row v-if="avgSwisetRatio !== 0" align="center" justify="center">
        <v-col>
          <h1 :style="`color: #${(avgSwisetRatio => 0)? 'var(--v-darkGreen-base)' : 'EF5350'}`" class="text-center">{{ String(Number(avgSwisetRatio.toFixed(2))) }}</h1>
          <p class="text-center">{{ $t('avgSwisetRatioTitle') }}</p>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <p class="mb-5 mr-2">{{ $t('firstFilterText') }}</p>
        <v-select :disabled="loadingPerformance" @change="getPerformanceOverview" style="max-width: 15%" :items="channels"
                  item-text="name" item-value="id" v-model="channelSelected" dense outlined/>
        <p class="mb-5 mx-2">{{ $t('secondFilterText') }}</p>
        <v-select :disabled="loadingPerformance" @change="getPerformanceOverview" style="max-width: 15%" :items="times"
                  item-text="text" item-value="value" v-model="timeSelected" dense outlined/>
        <p class="mb-5 mx-2">{{ $t('thirdFilterText') }}</p>
        <v-select :disabled="loadingPerformance" @change="getPerformanceOverview" style="max-width: 12%" :items="minTrades"
                  item-text="text" item-value="value" v-model="minTradesSelected" dense outlined/>
        <p class="mb-5 mx-2">{{ $t('accountTypeFilterText') }}</p>
        <v-select :disabled="loadingPerformance" @change="getPerformanceOverview" style="max-width: 15%" :items="accountTypes"
                  multiple v-model="selectedAccountTypes" dense outlined/>
      </v-row>
      <v-row justify="center" align="center">
        <v-checkbox :disabled="loadingPerformance" v-model="checkVerifiedAccounts" @change="verifiedCheckChanged"
                    :label="$t((checkVerifiedAccounts)? 'verifiedChecked' : 'verifiedNotChecked')"/>
      </v-row>
      <v-row>
        <v-data-table style="width: 100%" :headers="headers" :items="filteredPerformances" :no-data-text="$t('table_ClubPerformance.notFound')" :loading="loadingPerformance" :loading-text="$t('table_ClubPerformance.loading')">
          <template v-slot:item.traderName="{ item }">
            <div class="d-flex align-center justify-start">
              <v-avatar size="25">
                <v-img :src="(item.traderImageUrl !== null)? item.traderImageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain/>
              </v-avatar>
              <p class="ml-2 my-0">{{ truncateString(item.traderName, 20) }}</p>
            </div>
          </template>
          <template v-slot:item.accountName="{ item }">
            <p class="my-0">
              <img v-if="item.verifiedAccount" src="@/assets/icons/Audited.svg" alt="Audited Icon" class="mr-1" style="width: 12px; height: 12px; color: blue;" />
              {{ truncateString(item.accountName, 30) }}
            </p>
          </template>
          <template v-slot:item.swisetRatio="{ item }">
            <p class="my-0">
              {{ Number(item.swisetRatio.toFixed(2)).toString() }}
              <v-chip class="ml-1" v-if="verifyBestSwisetRatio(item.swisetRatio)" :color="`#${$store.state.clubMember.club.primaryColor}`" outlined x-small>
              <v-icon :color="`#${$store.state.clubMember.club.primaryColor}`" class="mr-1" x-small>fa-star</v-icon>
                <font style="font-size: 14px">Top</font>
              </v-chip>
            </p>
          </template>
          <template v-slot:item.winRate="{ item }">
            <p class="my-0">
              {{ Number((item.winRate * 100).toFixed(2)).toString() }}%
              <v-chip class="ml-1" v-if="verifyBestWinningRatio(item.winRate)" :color="`#${$store.state.clubMember.club.primaryColor}`" outlined x-small>
                <v-icon :color="`#${$store.state.clubMember.club.primaryColor}`" class="mr-1" x-small>fa-star</v-icon>
                <font style="font-size: 14px">Top</font>
              </v-chip>
            </p>
          </template>
          <template v-slot:item.riskReward="{ item }">
            <p class="my-0">
              1:{{ Number(item.riskReward.toFixed(2)).toString() }}
              <v-chip class="ml-1" v-if="verifyBestRiskReward(item.riskReward)" :color="`#${$store.state.clubMember.club.primaryColor}`" outlined x-small>
                <v-icon :color="`#${$store.state.clubMember.club.primaryColor}`" class="mr-1" x-small>fa-star</v-icon>
                <font style="font-size: 14px">Top</font>
              </v-chip>
            </p>
          </template>
          <template v-slot:item.profitFactor="{ item }">
            <p class="my-0">
              {{ Number(item.profitFactor.toFixed(3)).toString() }}
              <v-chip class="ml-1" v-if="verifyBestProfitFactor(item.profitFactor)" :color="`#${$store.state.clubMember.club.primaryColor}`" outlined x-small>
                <v-icon :color="`#${$store.state.clubMember.club.primaryColor}`" class="mr-1" x-small>fa-star</v-icon>
                <font style="font-size: 14px">Top</font>
              </v-chip>
            </p>
          </template>
        </v-data-table>
      </v-row>
      <v-row v-if="tradersCount !== 0" align="center" justify="center">
        <v-icon class="mr-3" small>fa-users</v-icon>
        <p style="color: #585a61" class="my-0 mr-3">{{ $t('tradersCount', { count: tradersCount }) }}</p>
        <v-chip @click="exportCSV" small>{{ $t('btnDownloadData') }} <v-icon class="ml-2" x-small>fa-share</v-icon></v-chip>
      </v-row>
    </v-container>
    <v-overlay :dark="false" v-model="blurConfig.isBlurred" absolute opacity="0">
      <UnavailableFeature/>
    </v-overlay>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import UnavailableFeature from './UnavailableFeature';
import { mapMutations } from 'vuex';

export default {
  name: "ClubPerformance",
  components: {UnavailableFeature},
  data() {
    return {
      loadingPerformance: true,
      tradersCount: 0,

      blurConfig: {
        isBlurred: true,
        opacity: 1,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      },

      times: [
        { text: this.$t('months_ClubPerformance.one'), value: '1' },
        { text: this.$t('months_ClubPerformance.two'), value: '2' },
        { text: this.$t('months_ClubPerformance.three'), value: '3' },
      ],
      minTrades: [
        { text: '100 trades', value: '100' },
        { text: '50 trades', value: '50' },
        { text: '25 trades', value: '25' },
        { text: '10 trades', value: '10' },
        { text: '1 trade', value: '1' },
      ],
      channels: [],
      accountTypes: [
        { text: 'Live', value: 'Live' },
        { text: 'Demo', value: 'Demo' },
      ],
      selectedAccountTypes: ['Live','Demo'], // Default to Live accounts

      timeSelected: '',
      minTradesSelected: '',
      channelSelected: 0,

      // Table
      performances: [],
      filteredPerformances: [],
      checkVerifiedAccounts: false,
      avgSwisetRatio: 0,
      bestSwisetRatio: 0,
      bestWinningRatio: 0,
      bestRiskReward: 0,
      bestProfitFactor: 0,
      headers: [
        { text: this.$t('headers_ClubPerformance.trader'), value: 'traderName', align: 'left', sortable: false, filterable: true, },
        { text: this.$t('headers_ClubPerformance.account'), value: 'accountName', align: 'left', sortable: false, filterable: true, },
        { text: this.$t('headers_ClubPerformance.swisetRatio'), value: 'swisetRatio', align: 'left', sortable: true, filterable: false, },
        { text: this.$t('headers_ClubPerformance.winRate'), value: 'winRate', align: 'left', sortable: true, filterable: false, },
        { text: this.$t('headers_ClubPerformance.riskReward'), value: 'riskReward', align: 'left', sortable: true, filterable: false, },
        { text: this.$t('headers_ClubPerformance.profitFactor'), value: 'profitFactor', align: 'left', sortable: true, filterable: false, },
        { text: this.$t('headers_ClubPerformance.trades'), value: 'trades', align: 'center', sortable: true, filterable: false, },
      ]
    };
  },
  watch: {
    performances() {
      this.updateTradersCount();
    },
    filteredPerformances() {
      this.updateTradersCount();
    },
  },
  mounted() {
    if(!(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN'))
      this.$router.push('/club');
    else
      this.init();
  },
  methods: {
    ...mapMutations(['setClubChannels']),
    init() {
      this.channels = [{ id: -1, name: 'GENERAL' }];
      Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubChannels(response.data);
          this.channels.push.apply(this.channels, response.data);
      });
      this.setDefaults();
      this.getPerformanceOverview();
      this.validateFeatureAvailable();
    },
    setDefaults() {
      this.channelSelected = this.channels[0].id;
      this.timeSelected = this.times[0].value;
      this.minTradesSelected = this.minTrades[0].value;
      this.selectedAccountTypes = ['Live', 'Demo']; // Set default
    },
    validateFeatureAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'CONSOLIDATED_RETURNS') {
          this.blurConfig.isBlurred = false;
          break;
        }
      }
    },
    updateTradersCount() {
      let traders = this.groupBy(this.filteredPerformances, 'traderId');
      this.tradersCount = Object.keys(traders).length;
    },
    groupBy (xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    verifyBestSwisetRatio(swisetRatio) {
      return swisetRatio === this.bestSwisetRatio;
    },
    verifyBestWinningRatio(winRate) {
      return winRate === this.bestWinningRatio;
    },
    verifyBestRiskReward(riskReward) {
      return riskReward === this.bestRiskReward;
    },
    verifyBestProfitFactor(profitFactor) {
      return profitFactor === this.bestProfitFactor;
    },
    getPerformanceOverview() {
      this.loadingPerformance = true;
      let performanceRequirements = {
        clubId: this.$store.state.clubMember.club.id,
        channelId: this.channelSelected,
        monthsAgo: Number(this.timeSelected),
        minTrades: Number(this.minTradesSelected),        
        accountTypes: this.selectedAccountTypes.map((accountType) => accountType.toUpperCase()),
      };

      Repository.getClubPerformance(performanceRequirements).then((response) => {
        if(response.status < 400) {
          this.performances = response.data.accountSummaryList;
          this.verifiedCheckChanged();

          this.bestSwisetRatio = response.data.bestSwisetRatio;
          this.bestWinningRatio = response.data.bestWinningRatio;
          this.bestRiskReward = response.data.bestRiskReward;
          this.bestProfitFactor = response.data.bestProfitFactor;
          this.calculateAvgSwisetRatio();
          this.loadingPerformance = false;
        }
      });
      this.updateTradersCount();
    },
    calculateAvgSwisetRatio() {
      this.avgSwisetRatio = 0;

      this.filteredPerformances.forEach((accountPerformance) => {
        this.avgSwisetRatio += accountPerformance.swisetRatio;
      });
      if(this.filteredPerformances.length > 0)
        this.avgSwisetRatio /= this.filteredPerformances.length;
    },
    verifiedCheckChanged() {
      this.filteredPerformances = (this.checkVerifiedAccounts)? this.performances.filter((account) => account.verifiedAccount) : this.performances;
      this.calculateAvgSwisetRatio();
    },
    exportCSV() {
      let rows = [['Trader Name', 'Account Name', 'Verified Account', 'Swiset Ratio', 'Win Rate', 'Risk/Reward', 'Profit Factor', 'Net Profit'],];

      this.performances.forEach((performance) => {
        rows.push([
          `${performance.traderName}`,
          `${performance.accountName}`,
          `${(performance.verifiedAccount)? 'True' : 'False'}`,
          `${performance.swisetRatio}`,
          `${performance.winRate}`,
          `${performance.riskReward}`,
          `${performance.profitFactor}`,
          `${performance.netProfit}`,
        ]);
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

      // Encoding and data downloading
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "Community Performance.csv");
      document.body.appendChild(link);
      link.click();
      alert(this.$t('successfulDownloadFromData', { rows: rows.length }));
    },
    capitalize(string){
      return this.truncateString(string[0] + string.slice(1).toLowerCase(), 30);
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength) ? `${string.substring(0, maxLength)}...` : string;
    },
  }
}
</script>



<style scoped>
h2{
  color: var(--v-mainBlack-base) !important;
}
</style>
